import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

const WaitForConsentApiLoaded = ({ placeHolder, onLoadRender }) => {
    const isTcfLoaded = useSelector(state => state.ads.isTcfLoaded);
    if (!isTcfLoaded) return placeHolder || null; // Return ads placeholder until Tcf is loaded
    return <>{onLoadRender()}</>;
};

WaitForConsentApiLoaded.propTypes = {
    placeHolder: PropTypes.node,
    onLoadRender: PropTypes.func.isRequired
};

export default WaitForConsentApiLoaded;
